'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var Paragraph = require('@narvar/nth-bit-paragraph');
var Button = require('@narvar/nth-block-button');
var LinkIcon = require('@narvar/nth-bit-icon-link');
var CopyIcon = require('@narvar/nth-bit-icon-copy');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');
var PrefetchData = require('../PrefetchData.js');
var SharingOptions_module = require('./SharingOptions.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);
var Paragraph__default = /*#__PURE__*/_interopDefaultLegacy(Paragraph);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var LinkIcon__default = /*#__PURE__*/_interopDefaultLegacy(LinkIcon);
var CopyIcon__default = /*#__PURE__*/_interopDefaultLegacy(CopyIcon);

const SharingOptions = ({
  giftTrackingSharingMessageSubject,
  giftTrackingSharingMessageBody,
  featureName,
  giftTrackingLink
}) => {
  const [isCopied, setIsCopied] = React.useState(false);
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  const {
    bodytextDefaultNone: bodyTextStyle,
    inputtextinputsNoneNone: inputStyle
  } = nthHookTheme.useTheme();
  const {
    giftTrackingSendEmailPrompt,
    giftTrackingSendEmailButtonText,
    giftTrackingCopyLinkPrompt,
    giftTrackingCopyLinkSuccessMessage
  } = nthHookTranslations.useTranslations();
  const handleSendEmail = () => {
    window.open(`mailto:?subject=${giftTrackingSharingMessageSubject}&body=${giftTrackingSharingMessageBody}`);
    logEvent({
      clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.SEND_EMAIL,
      clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.GIFT_TRACKING,
      clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
      eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
      eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
      eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
      feature: featureName,
      pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING
    });
  };
  const handleCopyLink = async () => {
    try {
      await window.navigator.clipboard.writeText(giftTrackingLink);
      logEvent({
        clickCategory: nthHookContextAnalytics.NarvarClickSubTypes.COPY_LINK,
        clickSubType: nthHookContextAnalytics.NarvarClickSubTypes.GIFT_TRACKING,
        clickType: nthHookContextAnalytics.NarvarClickTypes.INTERACTION,
        eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
        eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING,
        eventType: nthHookContextAnalytics.NarvarEventTypes.CLICK,
        feature: featureName,
        pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_PACK_GIFT_TRACKING
      });
      setIsCopied(true);
    } catch (err) {
      // TODO: Round out the experience with a proper error state
      // eslint-disable-next-line no-console
      console.error(err);
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], {
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    className: SharingOptions_module["default"].shareOptionsContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: SharingOptions_module["default"].shareOptionsButton
  }, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName
  }, giftTrackingSendEmailPrompt), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    big: true,
    onClick: handleSendEmail,
    featureName: featureName
  }, giftTrackingSendEmailButtonText)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: SharingOptions_module["default"].shareOptionsForm
  }, /*#__PURE__*/React__default["default"].createElement(Paragraph__default["default"], {
    featureName: featureName
  }, giftTrackingCopyLinkPrompt), /*#__PURE__*/React__default["default"].createElement("div", {
    className: SharingOptions_module["default"].linkBox
  }, /*#__PURE__*/React__default["default"].createElement(LinkIcon__default["default"], {
    s: {
      marginLeft: '0.25rem'
    },
    featureName: featureName
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    className: SharingOptions_module["default"].linkText,
    value: giftTrackingLink,
    style: inputStyle,
    onFocus: e => e.target.select(),
    readOnly: true
  }), /*#__PURE__*/React__default["default"].createElement("button", {
    className: SharingOptions_module["default"].copyLinkButton,
    "aria-label": giftTrackingCopyLinkPrompt || 'Copy Link'
    // TODO: refactor instead of disable
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    ,
    onClick: handleCopyLink
  }, /*#__PURE__*/React__default["default"].createElement(CopyIcon__default["default"], {
    featureName: featureName
  }))), /*#__PURE__*/React__default["default"].createElement("div", {
    role: "region",
    "aria-live": "polite"
  }, isCopied && /*#__PURE__*/React__default["default"].createElement("div", {
    className: SharingOptions_module["default"].copyLinkSuccessText,
    style: bodyTextStyle
  }, giftTrackingCopyLinkSuccessMessage)))));
};
const SharingOptionsWithData = nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(SharingOptions, {
  themeTokens: ['linksNoneDefault', 'linksNoneHover', 'bodytextDefaultNone', 'inputtextinputsNoneNone']
}), {
  translationKeys: ['giftTrackingSendEmailPrompt', 'giftTrackingSendEmailButtonText', 'giftTrackingCopyLinkPrompt', 'giftTrackingCopyLinkSuccessMessage']
});
const SharingOptionsWithPretchedData = ({
  featureName,
  ...props
}) => /*#__PURE__*/React__default["default"].createElement(PrefetchData["default"], {
  featureName: featureName
}, /*#__PURE__*/React__default["default"].createElement(SharingOptionsWithData, _extends__default["default"]({
  featureName: featureName
}, props)));

exports["default"] = SharingOptionsWithPretchedData;
